export default __webpack_public_path__ + "static/media/logo.f2786ac5.png";